import React, {useEffect} from 'react'

const PrivacyPolicy = () => {
  useEffect(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, []);
    return (
      <div>
         <div className="terms-conditions">
              <h1>Privacy Policy</h1>
              <h2>What Information We Collect</h2>
              <ul>
                  <li>We do not collect any personal information through our website or app.</li>
                  <li>The only information we handle is provided by users when they voluntarily fill out a booking form (e.g., name, contact details, guest info). This information is used solely for the purpose of managing hotel bookings.</li>
              </ul>
              <h2>Use of Google Services</h2>
              <ul>
                  <li>We use Google Drive only to display our own hotel images in the gallery.</li>
                  <li>We do not request access to users' Google accounts, emails, or photos.</li>
              </ul>
          
              <h2>Data Usage and Sharing</h2>
              <ul>
                  <li>We do not sell, share, or distribute your personal data to any third party. All collected information is used strictly for booking and customer support purposes.</li>
              </ul>
              <h2>Security</h2>
              <ul>
                  <li>We use standard security measures to protect your information and ensure it is not misused, accessed, or altered by unauthorized parties.</li>
              </ul>
              <h2>Your Rights</h2>
              <ul>
                  <li>If you would like us to delete your booking information after your stay or have any concerns, you may contact us directly.</li>
              </ul>
              <h3>Regards</h3> <strong>HOTEL SHYAM PALACE GHANGRIA</strong>
          </div>
      </div>
    )
}

export default PrivacyPolicy
